require('./PayrollLoanRequestView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { isEqual } = require('lodash/lang');

// @common
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const PayrollLoanRequest = require('../../components/contracts/contractPayrollLoan/payrollLoanRequest/payrollLoanRequest/payrollLoanRequest');
const LoansError = require('components/loansAndMortgages/loans/loansError/loansError');
//@core
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @ actions
const collectiveActions = require('actions/collectives');
const PrinterActions = require('actions/contactCenter/printer');
const PayrollLoanRequestActions = require('../../actions/payrollLoanRequest');
const LoanRecordStatusActions = require('../../actions/loanRecordStatus');
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');
const actionsAccount = require('actions/accounts');

// @constants
const { WIZARD_FIRST_STEP } = require('constants/index');
const {
    PERSONAL_LOAN_WAFFER
} = require('constants/flagBasedFeatures');

class PayrollLoanRequestView extends React.Component {

    componentWillMount() {
        const { match: { params: { step } }, validateStep } = this.props;

        if (!isEqual(step, undefined)) {
            this.setVisibleStep(parseInt(step));
        } else {
            validateStep(WIZARD_FIRST_STEP);
        }

        this.clearErrorsFile = this.clearErrorsFile.bind(this);
        this.setNameFile = this.setNameFile.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.loadFileInUpload = this.loadFileInUpload.bind(this);
        this.removeUploadedFile = this.removeUploadedFile.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures, validateBlockedAccount } = this.props;
        validateBlockedAccount();

        if (!immFlagBasedFeatures.get(PERSONAL_LOAN_WAFFER)) {
            window.location.href = "/myprofile/loans-mortgages/";
        }

        scrollToTop();
    }

    componentWillUnmount() {
        this.props.resetUploadConfig();
    }

    buildBreadcrumbConfig() {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('breadcrumb-payrollLoanRequest')
            }
        ];
    }

    loadFileInUpload(uploadName, file, idx) {
        const receiptDefaultName = formatText("payrollLoanRequestStepThree-payrollLoanRequestStepThree_receiptDefaultName");
        const messageSnackSuccess = formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadFileSuccess');
        const response = { uploadName, file, idx, receiptDefaultName, messageSnackSuccess };
        this.props.loadFileInUpload({ response });
    }

    clearErrorsFile(uploadName, idx, documentId) {
        this.props.clearErrorsFile({ uploadName, idx, documentId });
    }

    removeUploadedFile(uploadName, idx, documentId) {
        this.props.removeUploadedFile({ uploadName, idx, documentId });
    }

    setVisibleStep(visibleStep) {
        this.props.setVisibleStep({ visibleStep });
    }

    setNameFile(typeFile, nameFile, idx, documentId) {
        const receiptDefaultName = formatText("payrollLoanRequestStepThree-payrollLoanRequestStepThree_receiptDefaultName");
        const response = { typeFile, nameFile, idx, documentId, receiptDefaultName };
        this.props.handlerEditFileName({ response });
    }

    buildContent() {
        const {
            actionApprovalLetter,
            downloadINEDocument,
            immCollectives,
            immFlagBasedFeatures,
            immPayrollLoanRequest,
            downloadPreContractDocument,
            initialize,
            validateStep,
            getCollectiveInfo,
            getInstallment,
            getLoansForExpenses,
            getPersonalInformation,
            getProposition,
            payrollLoanSaveInProgress,
            match: { params },
            setCompanyMonths,
            setCompanyYears,
            setLoanAmount,
            setLoanTerm,
            setPurpose,
            setSubpurpose,
            setCivilStatus,
            setContractType,
            setCreditCard,
            setEmploymentLevel,
            setIncome,
            setJob,
            setNewJobType,
            setOutcome,
            setRegime,
            requestLoanApproval,
            finishBtnUploadDocumentsFlow,
            cancelLoanRecord,
            changeViewPreApprovalKOxDTI,
            resetCheckboxCirbe,
            resetUploadConfig,
            setCirbeCheck,
            setCurrentProductCollective,
            setLoanAmountKOxDTI,
            setLoanTermKOxDTI,
            setTotalSenorityFieldsDirty,
            setSenorityFieldsDirty,
            setWorkingTimeWrapper,
            setWorkingTimeWrapperFocus,
            getMinTerm,
            resetStep,
            resetStateWizard,
            resetPrintedIndicators,
            validateAmountKOxDTI,
            resetMinTermMaxAmount,
            loadFilesPersonalLoan,
            recoveryProcessType,
            checkReadDocument,
            checkCheckedDocument,
            immProfile,
            preContractualMail,
            requestProfile,
            sendMail,
            sendEasyLoanSimpleEmail,
            immPrinter,
            checkRadioButtonOffice,
            printDocumentOffice
        } = this.props;

        let content;

        const formHandlers = {
            handleActionApprovalLetter: actionApprovalLetter,
            handleCivilStatusChange: setCivilStatus,
            handleCompanyMonths: setCompanyMonths,
            handleCompanyYears: setCompanyYears,
            handleContractTypeChange: setContractType,
            handleCreditCardChange: setCreditCard,
            handleDownloadINE: downloadINEDocument,
            handleEmploymentLevelChange: setEmploymentLevel,
            handleIncomeChange: setIncome,
            handleJobRadioChange: setJob,
            handleJobTypeChange: setNewJobType,
            handleOutcomeChange: setOutcome,
            handleProposition: getProposition,
            handleRegimeChange: setRegime,
            handleSaveInProgress: payrollLoanSaveInProgress,
            handleWorkingTimeWrapper: setWorkingTimeWrapper,
            handleWorkingTimeWrapperFocus: setWorkingTimeWrapperFocus,
            handleSubpurposeChange: setSubpurpose,
            handleTotalSenorityFieldsDirty: setTotalSenorityFieldsDirty,
            handleSenorityFieldsDirty: setSenorityFieldsDirty,
        };

        const simulationToken = params.simulationToken;

        content = (
            <PayrollLoanRequest
                loadFileInUpload={this.loadFileInUpload}
                removeUploadedFile={this.removeUploadedFile}
                downloadPreContractDocument={downloadPreContractDocument}
                clearErrorsFile={this.clearErrorsFile}
                formHandlers={formHandlers}
                setPurpose={setPurpose}
                simulationToken={simulationToken}
                getCollectiveInfo={getCollectiveInfo}
                getInstallment={getInstallment}
                getLoansForExpenses={getLoansForExpenses}
                getPersonalInformation={getPersonalInformation}
                immCollectives={immCollectives}
                immFlagBasedFeatures={immFlagBasedFeatures}
                immPayrollLoanRequest={immPayrollLoanRequest}
                initialize={initialize}
                validateStep={validateStep}
                setCurrentProductCollective={setCurrentProductCollective}
                setLoanAmount={setLoanAmount}
                setLoanTerm={setLoanTerm}
                setVisibleStep={this.setVisibleStep}
                requestLoanApproval={requestLoanApproval}
                resetUploadConfig={resetUploadConfig}
                finishBtnUploadDocumentsFlow={finishBtnUploadDocumentsFlow}
                cancelLoanRecord={cancelLoanRecord}
                changeViewPreApprovalKOxDTI={changeViewPreApprovalKOxDTI}
                setLoanAmountKOxDTI={setLoanAmountKOxDTI}
                setLoanTermKOxDTI={setLoanTermKOxDTI}
                getMinTerm={getMinTerm}
                resetStep={resetStep}
                resetStateWizard={resetStateWizard}
                resetPrintedIndicators={resetPrintedIndicators}
                validateAmountKOxDTI={validateAmountKOxDTI}
                resetMinTermMaxAmount={resetMinTermMaxAmount}
                handlerEditFileName={this.setNameFile}
                loadFilesPersonalLoan={loadFilesPersonalLoan}
                setCirbeCheck={setCirbeCheck}
                resetCheckboxCirbe={resetCheckboxCirbe}
                recoveryProcessType={recoveryProcessType}
                checkReadDocument={checkReadDocument}
                checkCheckedDocument={checkCheckedDocument}
                immProfile={immProfile}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                sendMail={sendMail}
                sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                immPrinter={immPrinter}
                checkRadioButtonOffice={checkRadioButtonOffice}
                printDocumentOffice={printDocumentOffice}
                isPayrrolLoan={true}
            />
        );

        return content;
    }

    buildHeader() {
        const breadcrumb = this.buildBreadcrumbConfig();

        return (
            <OKCover
                size="medium"
                section="generic"
                customClass="payroll-loan-request-view__header-container"
            >
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumb}
                    finalTitle={getFinalTitle('payrollLoanRequestStepOne-title')}
                />
            </OKCover>
        );
    }

    render() {
        const { hiringProductBanners } = this.props;
        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <section className="grid-view payroll-loan-request-view">
                {header}
                {
                    isAccountBlockedValidationFetching ?
                        <div className="contract-pre-granted-credit-view__loading"><LoadingSection /></div>
                        :
                        isAccountBlockedValidationError ?
                            <div className="payroll-loan-request row"><LoansError /></div>
                            :
                            content
                }
            </section>
        );
    }
}

PayrollLoanRequestView.propTypes = {
    actionApprovalLetter: PropTypes.func.isRequired,
    cancelLoanRecord: PropTypes.func.isRequired,
    changeViewPreApprovalKOxDTI: PropTypes.func.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
    downloadINEDocument: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    finishBtnUploadDocumentsFlow: PropTypes.func.isRequired,
    getCollectiveInfo: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    getLoansForExpenses: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    getPersonalInformation: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    handlerEditFileName: PropTypes.func.isRequired,
    hiringProductBanners: PropTypes.object.isRequired,
    immCollectives: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPayrollLoanRequest: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    loadFilesPersonalLoan: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    payrollLoanSaveInProgress: PropTypes.func.isRequired,
    requestLoanApproval: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    resetCheckboxCirbe: PropTypes.func.isRequired,
    resetMinTermMaxAmount: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    resetStateWizard: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    resetUploadConfig: PropTypes.func.isRequired,
    setCirbeCheck: PropTypes.func.isRequired,
    setCivilStatus: PropTypes.func.isRequired,
    setCompanyMonths: PropTypes.func.isRequired,
    setCompanyYears: PropTypes.func.isRequired,
    setContractType: PropTypes.func.isRequired,
    setCreditCard: PropTypes.func.isRequired,
    setCurrentProductCollective: PropTypes.func.isRequired,
    setIncome: PropTypes.func.isRequired,
    setOutcome: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    setRegime: PropTypes.func.isRequired,
    setSubpurpose: PropTypes.func.isRequired,
    setEmploymentLevel: PropTypes.func.isRequired,
    setJob: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanAmountKOxDTI: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setLoanTermKOxDTI: PropTypes.func.isRequired,
    setNewJobType: PropTypes.func.isRequired,
    setTotalSenorityFieldsDirty: PropTypes.func.isRequired,
    setSenorityFieldsDirty: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWorkingTimeWrapper: PropTypes.func.isRequired,
    setWorkingTimeWrapperFocus: PropTypes.func.isRequired,
    validateAmountKOxDTI: PropTypes.func.isRequired,
    validateBlockedAccount: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports = connect(state => ({
    //state mapping
    hiringProductBanners: state.hiringProductBanners,
    immCollectives: state.collectives,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immPayrollLoanRequest: state.payrollLoanRequest,
    immProfile: state.profile,
    preContractualMail: state.preContractualMail,
    immPrinter: state.printer,

}), {
    //actions mapping
    actionApprovalLetter: PayrollLoanRequestActions.actionApprovalLetter,
    resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
    downloadINEDocument: PayrollLoanRequestActions.downloadINEDocument,
    downloadPreContractDocument: PayrollLoanRequestActions.downloadPreContractDocument,
    getCollectiveInfo: collectiveActions.getCollectiveInfo,
    getInstallment: PayrollLoanRequestActions.getInstallment,
    getLoansForExpenses: PayrollLoanRequestActions.getLoansForExpenses,
    getPersonalInformation: PayrollLoanRequestActions.getPersonalInformation,
    getProposition: PayrollLoanRequestActions.getProposition,
    payrollLoanSaveInProgress: PayrollLoanRequestActions.payrollLoanSaveInProgress,
    resetUploadConfig: PayrollLoanRequestActions.simpleActions.payrollLoanRequestUploadFileReset,
    setLoanAmount: PayrollLoanRequestActions.setLoanAmount,
    setLoanTerm: PayrollLoanRequestActions.setLoanTerm,
    setVisibleStep: PayrollLoanRequestActions.simpleActions.payrollLoanRequestSetVisibleStep,
    validateBlockedAccount: actionsAccount.validateBlockedAccount,
    validateStep: PayrollLoanRequestActions.validateStep,
    setPurpose: PayrollLoanRequestActions.setPurpose,
    setCivilStatus: PayrollLoanRequestActions.setCivilStatus,
    setCirbeCheck: PayrollLoanRequestActions.simpleActions.payrollLoanRequestSetCirbeCheck,
    setCompanyMonths: PayrollLoanRequestActions.setCompanyMonths,
    setCompanyYears: PayrollLoanRequestActions.setCompanyYears,
    setContractType: PayrollLoanRequestActions.setContractType,
    setCreditCard: PayrollLoanRequestActions.setCreditCard,
    setCurrentProductCollective: PayrollLoanRequestActions.simpleActions.payrollLoanRequestSetCollective,
    setEmploymentLevel: PayrollLoanRequestActions.setEmploymentLevel,
    setIncome: PayrollLoanRequestActions.setIncome,
    setJob: PayrollLoanRequestActions.setJob,
    setNewJobType: PayrollLoanRequestActions.setNewJobType,
    setOutcome: PayrollLoanRequestActions.setOutcome,
    setRegime: PayrollLoanRequestActions.setRegime,
    setSubpurpose: PayrollLoanRequestActions.setSubpurpose,
    setWorkingTimeWrapper: PayrollLoanRequestActions.setWorkingTimeWrapper,
    setWorkingTimeWrapperFocus: PayrollLoanRequestActions.setWorkingTimeWrapperFocus,
    initialize: PayrollLoanRequestActions.initialize,
    resetCheckboxCirbe: PayrollLoanRequestActions.simpleActions.payrollLoanRequestResetCheckboxCirbe,
    requestLoanApproval: PayrollLoanRequestActions.requestLoanApproval,
    loadFileInUpload: PayrollLoanRequestActions.uploadFilesForPersonalLoan,
    removeUploadedFile: PayrollLoanRequestActions.removeFileForPersonalLoan,
    clearErrorsFile: PayrollLoanRequestActions.clearErrors,
    finishBtnUploadDocumentsFlow: PayrollLoanRequestActions.finishBtnUploadDocumentsFlow,
    cancelLoanRecord: LoanRecordStatusActions.cancelLoanRecord,
    changeViewPreApprovalKOxDTI: PayrollLoanRequestActions.changeViewPreApprovalKOxDTI,
    setLoanAmountKOxDTI: PayrollLoanRequestActions.setLoanAmountKOxDTI,
    setLoanTermKOxDTI: PayrollLoanRequestActions.setLoanTermKOxDTI,
    setTotalSenorityFieldsDirty: PayrollLoanRequestActions.simpleActions.payrollLoanRequestSetTotalSenorityFieldsDirty,
    setSenorityFieldsDirty: PayrollLoanRequestActions.simpleActions.payrollLoanRequestSetSenorityFieldsDirty,
    getMinTerm: PayrollLoanRequestActions.getMinTerm,
    resetStep: PayrollLoanRequestActions.resetStep,
    resetStateWizard: PayrollLoanRequestActions.simpleActions.payrollLoanRequestReset,
    validateAmountKOxDTI: PayrollLoanRequestActions.validateAmountKOxDTI,
    resetMinTermMaxAmount: PayrollLoanRequestActions.simpleActions.payrollLoanRequestResetMinTermMaxAmount,
    handlerEditFileName: PayrollLoanRequestActions.editNameFilesForPersonalLoan,
    loadFilesPersonalLoan: PayrollLoanRequestActions.loadFilesPersonalLoan,
    recoveryProcessType: PayrollLoanRequestActions.recoveryProcessType,
    checkReadDocument: PayrollLoanRequestActions.checkReadDocument,
    checkCheckedDocument: PayrollLoanRequestActions.checkCheckedDocument,
    requestProfile: profileActions.requestProfile,
    sendMail: preContractualMailInfoActions.sendLoanPreContractualMail,
    sendEasyLoanSimpleEmail: PayrollLoanRequestActions.sendPayrollLoanSimpleEmail,
    checkRadioButtonOffice: PayrollLoanRequestActions.checkRadioButtonOffice,
    printDocumentOffice: PayrollLoanRequestActions.printDocumentOffice

})(PayrollLoanRequestView);
